import { useMemo, useEffect } from "react";
import useUDTopics from "hooks/UD/useUDTopics";
import useUDCompareTopics from "hooks/UD/useUDCompareTopics";
import { findEdition2VariableId } from "../../utils/findEdition2VariableId";
import { findKeyVariableInTopics } from "../../utils/findKeyVariableInTopics";

import Select from "components/Select";
import RevertGrouping from "./components/RevertGrouping";

export default function UDResultsMain({
   params,
   onChange
}) {

   const isCompareMode = params?.compare_mode === "compare";
   const { d: topics } = useUDTopics( isCompareMode ? null : params.edition );
   const { d: compareTopics } = useUDCompareTopics( 
      isCompareMode ? params.edition : null, 
      isCompareMode ? params.edition2 : null 
   );
   
   // W trybie porównania potrzebujemy topics z obu edycji do mapowania ID
   const { d: topicsEdition1 } = useUDTopics( isCompareMode ? params.edition : null );
   const { d: topicsEdition2 } = useUDTopics( isCompareMode ? params.edition2 : null );

   const displayTopics = isCompareMode ? compareTopics : topics;
   

   const key_variable_options = useMemo(() => {
      if (!displayTopics || !Array.isArray(params.key_variable_ids)) return null;

      const grouping_variable_ids = params.grouping_variable_ids || [];

      return params.key_variable_ids
         .map(id => {
            const item = findKeyVariableInTopics(id, displayTopics, isCompareMode);
            if (item) {
               return { 
                  value: id, 
                  label: item.name || "Zmienna",
                  disabled: grouping_variable_ids.some(gid => String(gid) === String(id))
               };
            }
            return undefined;
         })
         .filter(Boolean);
   }, [ displayTopics, params.key_variable_ids, params.grouping_variable_ids, isCompareMode ]);

   useEffect(() => {
      // Jeśli key_variable_ids jest ustawione, ale key_variable_id nie, ustaw pierwszy z listy
      if (params.key_variable_ids && params.key_variable_ids.length > 0 && !params.key_variable_id) {
         const firstId = params.key_variable_ids[0];
         const firstIdNum = Number(firstId);
         if (isCompareMode) {
            const edition2Id = findEdition2VariableId(firstId, displayTopics, topicsEdition1, topicsEdition2);
            onChange?.({
               key_variable_id: firstId,
               key_variable_id_edition2: edition2Id || firstId
            });
         } else {
            onChange?.("key_variable_id", firstId);
         }
         return;
      }
      
      if (!key_variable_options) return;
      if (!params.key_variable_id && key_variable_options.length) {
         const selectedOption = key_variable_options[0];
         if (isCompareMode) {
            const edition2Id = findEdition2VariableId(selectedOption.value, displayTopics, topicsEdition1, topicsEdition2);
            onChange?.({
               key_variable_id: selectedOption.value,
               key_variable_id_edition2: edition2Id || selectedOption.value
            });
         } else {
            onChange?.("key_variable_id", selectedOption.value);
         }
      }
   }, [ key_variable_options, params.key_variable_id, onChange, isCompareMode, displayTopics, topicsEdition1, topicsEdition2 ]);

   return (
      <>
         <Select
            name="key_variable_id"
            value={ params.key_variable_id}
            label="Wybierz wyświetlane dane:"
            label_style={{ flex: "0 0 220px" }}
            style={{ maxWidth: "calc(100vw - 50px)" }}
            options={ key_variable_options }
            onChange={(name, value) => {
               // Jeśli wybrano zmienną kluczową, która jest już w zmiennych grupujących, usuń ją z grupujących
               const grouping_variable_ids = params.grouping_variable_ids || [];
               const filtered_grouping = grouping_variable_ids.filter(id => String(id) !== String(value));
               
               if (isCompareMode) {
                  const edition2Id = findEdition2VariableId(value, displayTopics, topicsEdition1, topicsEdition2);
                  const updateData = {
                     [name]: value,
                     key_variable_id_edition2: edition2Id || value
                  };
                  if (filtered_grouping.length !== grouping_variable_ids.length) {
                     updateData.grouping_variable_ids = filtered_grouping;
                  }
                  onChange(updateData);
               } else {
                  if (filtered_grouping.length !== grouping_variable_ids.length) {
                     onChange({
                        [name]: value,
                        grouping_variable_ids: filtered_grouping
                     });
                  } else {
                     onChange(name, value);
                  }
               }
            }}
         />

         <RevertGrouping params={ params } onChange={ onChange }/>

         <div className="divider" />
      </>
   );
}